export default {"src":"/_next/static/media/warning.5c3406b5.svg","height":12,"width":12};